<template>
    <div>
        <div class="shop_product_count tw-flex tw-justify-between">
            <div class="tw-cursor-pointer view-switcher" :class="{active:view_mode=='grid'}" title="плитка">
                <svg xmlns="http://www.w3.org/2000/svg" @click="switch_mode('grid')" width="32px" id="i-view-mode--grid" viewBox="0 0 44 44">
                    <path d="M27 31h4v-4h-4v4zM27 24h4v-4h-4v4zM27 17h4v-4h-4v4zM20 31h4v-4h-4v4zM20 24h4v-4h-4v4zM20 17h4v-4h-4v4zM13 31h4v-4h-4v4zM13 24h4v-4h-4v4zM13 17h4v-4h-4v4z"></path>
                </svg>
            </div>
            <div class="tw-cursor-pointer view-switcher " :class="{active:view_mode=='list'}" title="список">
                <svg xmlns="http://www.w3.org/2000/svg" @click="switch_mode('list')" width="32px" id="i-view-mode--pricelist" viewBox="0 0 44 44">
                    <path d="M13 31h18v-4H13v4zM13 24h18v-4H13v4zM13 17h18v-4H13v4z"></path>
                </svg>
            </div>
        </div>
        <div class="shop_sorting1 float-right">
            <!--            <span>{{translate('sort_by')}}:</span>-->
            <!--            <ul>-->
            <!--                <li>-->
            <!--                    <span class="sorting_text">{{translate('sort_price_up')}}<i-->
            <!--                            class="fas fa-chevron-down"></i></span>-->
            <!--                    <ul>-->
            <!--                        <li v-for="(option,index) in sort_options.items" class="shop_sorting_button" v-text="option.text" @click="changeSorting('price','asc')"></li>-->
            <!--                    </ul>-->
            <!--                </li>-->
            <!--            </ul>-->
            <!--            <span class="sorting_text">{{translate('sort_price_up')}}-->
            <!--                <i class="fas fa-chevron-down"></i>-->
            <!--            </span>-->
<!--            <select name="s" id="s1">-->
<!--                <option v-for="(option,index) in sort_options.items" v-text="option.text" value=""></option>-->
<!--            </select>-->
            <div class="sort-by__select"><span class="sort-by__current">{{current}}</span>
                <ul class="sort-by__list">
                    <li v-for="(option,index) in sort_items"
                        v-text="option.text"
                        :title="option.text"
                        class="sort-by__item"
                    @click="changeSorting(option.code)">
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "CatalogToolBar",
        props: ['locale', 'sorting_data','view_mode_start'],
        data() {
            return {
                trans: {
                    'sort_by': {
                        'ru': 'Сортировка',
                        'uk': 'Сортування',
                    },
                    'sort_rated': {
                        'ru': 'по популярности',
                        'uk': 'за популярністю',
                    },
                    'sort_price_up': {
                        'ru': 'по возрастанию цены',
                        'uk': 'за зростанням ціни',
                    },
                    'sort_price_down': {
                        'ru': 'по убыванию цены',
                        'uk': 'за зменшенням ціни',
                    },
                    'sort_new': {
                        'ru': 'новинки',
                        'uk': 'новинки',
                    },
                },
                sort_options: {},
                view_mode:'',
            }
        },
        mounted() {
            this.sort_options = JSON.parse(this.sorting_data);
            this.view_mode = this.view_mode_start;
        },
        methods: {
            translate(sentence) {
                return this.trans[sentence][this.locale];
            },
            changeSorting(code) {
                if (history.pushState) {
                    let newurl = window.location.href.split('?')[0];
                    window.history.pushState({path:newurl},'',newurl);
                }
                axios
                    .post(document.URL, {
                        'sort_method': code,
                    })
                    .then(response => {
                        EventBus.$emit('resetPageNumber',response.data.last_page);
                        $('#products').html(response.data.products);
                        this.sort_options = response.data.sorting;
                    })
                    .catch();
            },
            switch_mode(mode){
                axios
                    .post(document.URL, {
                        'view_mode': mode,
                    })
                    .then(response => {
                        $('#products').html(response.data.products);
                        this.view_mode = response.data.view_mode;
                    })
                    .catch();
            }
        },
        computed:{
            current(){
                // return 'ff';
                 if(Object.keys(this.sort_options).length > 0){
                     return this.sort_options.items[this.sort_options.current].text;
                 }
                return '';
            },
            sort_items(){
                if(Object.keys(this.sort_options).length > 0){
                    let current = this.sort_options.current;
                    let new_array = this.sort_options.items.filter(function(v,i){
                        return i !== current;
                    });
                    return new_array;
                }
            }
        }
    }
</script>

<style scoped>
    select {
        -webkit-appearance: button;
        -moz-appearance: button;
    }

    .sort-by__select {
        position: relative;
        display: inline-block;
        min-width: 188px;
        border: 1px solid #e0e0e0;
        border-radius: 2px;
        background: #fff;
        margin-left: 8px;
        vertical-align: middle;
    }

    .sort-by__select:hover ul{
        /*display: block;*/
        opacity:1;
        transition:opacity 1000ms;
    }

    .sort-by__current, .sort-by__item {
        display: block;
        padding: 6px 21px 4px 7px;
        line-height: 18px;
        font-weight: 400;
        font-size: 13px;
        letter-spacing: .4px;
        text-transform: lowercase;
        color: #595959;
        cursor:pointer;
    }

    .sort-by__item:hover {
        background-color: #3182ce;
        color:white;
    }

    .sort-by__current {
        cursor: pointer;
    }

    .sort-by__list {
        /*display: none;*/
        opacity:0;
        border: 1px solid #e0e0e0;
        position: absolute;
        background-color: white;
        width: -webkit-fill-available;
    }

    .view-switcher.active{
        background-color: #2497e3;
        border-radius: 3px;
        cursor: default !important;
    }
</style>
